import { render, staticRenderFns } from "./AddBadge.vue?vue&type=template&id=e2c15fa6&scoped=true&"
import script from "./AddBadge.vue?vue&type=script&lang=js&"
export * from "./AddBadge.vue?vue&type=script&lang=js&"
import style0 from "./AddBadge.vue?vue&type=style&index=0&id=e2c15fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c15fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSwitch,VTextField})
